module.exports = __webpack_public_path__ + "img/swiper3.cce614b7.png";